module.exports = class SubNavToggle {

    constructor(a) {

        this.a = a;

        a.addEventListener("click", (event) => {

            event.preventDefault();
            event.stopPropagation();

            this.Toggle();

        });

    }

    IsOpened() {

        return this.a.parentNode.dataset.toggle;

    }

    Toggle() {

        if (this.IsOpened()) {

            this.Close();

        } else {

            this.a.parentNode.dataset.toggle  = 1;

        }

    }

    Close() {

        delete this.a.parentNode.dataset.toggle;

    }
}